import { render, staticRenderFns } from "./creditorDialog.vue?vue&type=template&id=08d19873"
import script from "./creditorDialog.vue?vue&type=script&lang=js"
export * from "./creditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports